import { OnInit } from '@angular/core';
import { ClientService } from '../../shared/services/client.service';
import { AuthService } from '../../login/services/auth.service';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(authService, clientService) {
        this.authService = authService;
        this.clientService = clientService;
        this._assignments = [];
        this.loadingAssessments = true;
    }
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var clientOffset = 0; // start at 0 and retrieve up to 200 tests, which should be more than enough for an individual client assignment.
        var clientTestsLimit = 200; // retrieve as many of the tests as the client has as possible, default is 10 which we need more than that.
        this.authService.getCurrentClient().then(function (client) {
            if (client) {
                _this._client = client;
                _this._assignments = client.assignments;
            }
            else {
                console.error(" no client found, cannot load assessments");
            }
            _this.loadingAssessments = false;
        })
            .catch(function (error) {
            _this.loadingAssessments = false;
            console.log(error);
            // TODO: stephen need to display an error if there is nothing here.
        });
    };
    Object.defineProperty(DashboardComponent.prototype, "assessmentsStarted", {
        get: function () {
            return this._client && this._client.hasStartedAssignments();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "hasAssessments", {
        get: function () {
            return this._client && !this._client.hasNoAssignments();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "assessmentsCompleted", {
        get: function () {
            return this._client && this._client.hasFinishedAllAssignments();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardComponent.prototype, "assignments", {
        get: function () {
            if (!this._client) {
                return [];
            }
            return this._client.assignments;
        },
        enumerable: true,
        configurable: true
    });
    DashboardComponent.prototype.getNextTest = function () {
        var nextAssignment = this._client.getNextAssignmentItemToComplete();
        if (!nextAssignment) {
            console.error("System error, client get next assignment returned null");
        }
        return nextAssignment ? nextAssignment.Id : null;
    };
    return DashboardComponent;
}());
export { DashboardComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/dashboard/dashboard.component.ts.pre-build-optimizer.js